<template>
    <b-form
        class="step-form text-center registered-customer-id"
        @submit.stop.prevent="onSubmit"
    >
        <div class="row">
            <div class="col-lg-12">
                <div class="fields-area registration-completed">
                    <div class="row">
                        <div class="col-lg-12">
                            <h3>Thank you {{ FirstName }}</h3>
                            <p>
                                {{ registrationText }}
                            </p>
                            <p v-if="warning">
                                {{ warning }}
                            </p>

                            <!-- <div class="generated-customer-id">
                                <h4>{{ form.idenfoId }}</h4>
                                <p>UNIQUE CUSTOMER ID</p>
                            </div> -->
                        </div>
                    </div>
                </div>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    class="btn-min-width"
                    :btn-label="registrationBtnText"
                ></base-button>
            </div>
        </div>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            registrationText: "Your documents has been updated. You can now close this window",
            registrationBtnText: "Close",
            idenfoID: '',
            FirstName: null,
            country: process.env.VUE_APP_COUNTRY,
            customerInfo : {
                idenfoId : null,
                gender : null,
                nationality : null,
                fathersName : null,
                dob : null,
                name : null,
                cnic : null,
                cnicExpiry : null,
            }
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form', 'dataSegmentId', 'warning']),

        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.onLoad()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.onLoad()
        this.idenfoID = this.$store.state.registration.form.idenfoId
        this.FirstName = this.$store.state.registration.form.firstName

        this.customerInfo.idenfoId = this.idenfoID
        this.customerInfo.name = this.$store.state.registration.form.basicInfo.firstName
        this.customerInfo.gender = this.$store.state.registration.form.basicInfo.gender
        this.customerInfo.nationality = this.$store.state.registration.form.basicInfo.nationality
        this.customerInfo.fathersName = this.$store.state.registration.form.basicInfo.fatherName
        this.customerInfo.dob = this.$store.state.registration.form.basicInfo.dateOfBirth
        this.customerInfo.cnic = this.$store.state.registration.form.identityInfo.number
        this.customerInfo.cnicExpiry = this.$store.state.registration.form.identityInfo.expiryDate

        this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        onSubmit() {
            // if(this.country == "Malaysia"){
            //     window.location.href = 'https://www.idenfodirect.com/'
            // } else if (this.country == "Pakistan") {
            //     window.location.href = 'https://www.idenfodirect.com/pk'
            // }
            // else {
            //     window.location.href = 'https://www.idenfodirect.com/uae/'
            // }
            if(this.$route.path.includes('deep'))
            {
                window.location.href = process.env.VUE_APP_URL
            }
            else
            {  
                var myParam = this.$route.params.source

                let data = {
                    "source":"idenfo",
                    "status":"pass", //dynamic
                    "message":"Successfully onboarded", //dynamic
                    "customerInfo":this.customerInfo
                }
                if(myParam=='webView')
                {
                    window.ReactNativeWebView.postMessage(JSON.stringify(data))
                }
                else
                {   
                    // window.ReactNativeWebView.postMessage(JSON.stringify(data))

                   window.top.postMessage(data,'*')
                }
            }


            // if (this.$route.meta.publicRegistration === true) {
            //     this.$router.push({
            //         name: 'public-registration-setup-profile',
            //         params: {
            //             dataSegmentId: this.dataSegmentId,
            //         },
            //     })
            // } else {
            //     this.$router.push('/register-customer/setup-profile')
            // }
        }, // End of onSubmit() method

        /**
         * Handle when the page is loaded
         *
         * @return {void}
         */
        onLoad() {
            if (!this.form.idenfoId) {
                return this.onSubmit()
            }
            if (this.$route.meta.publicRegistration === true) {
                this.FirstName =
                    this.$store.state.registration.form.basicInfo.firstName
                this.registrationText =
                    ' Your account has been updated. You can now close this window'
                if(this.$route.path.includes('deep'))
                {
                    this.registrationBtnText = 'GO TO MAIN WEBSITE'
                }
                else
                {
                    this.registrationBtnText = 'CLOSE'
                }

            } else {
                this.registrationText =
                    ' Customer account has been created successfully.'
                this.registrationBtnText = 'REGISTER ANOTHER CUSTOMER'
            }
        }, // End of onLoad() method
    }, // End of Component > watch
} // End of export default
</script>
